import axios from 'axios';
import Vue from 'vue';
import store from '../vuex/store';
import CONST from '../constants';

const Http = {};

// use this var to make sure not to show other error messages while user is being logged out due to inactivity
var loggingOut = false;

// register axios globally
// window.axios = axios;

/*
* Load decorator for loader animation in v-loader directive areas
* Ajax calls with loader animation in a specific area need to be prefixed with the prototype method 'loader'.
* Loader accepts an argument 'area'. Area should be a unique identifier for the area that should contain the loader animation. E.g. 'sidebar'
*
* To make the area 'sidebar' listen to the loader event, it must provide the vue-directive 'v-loader'.
* You can find more information on how to use this directive at '@src/js/plugins/loader.js'.
*/
const loader = (area) =>
{
    let axiosInstance = axios.create();

    let requestInterceptors = request({
        up: () => Vue.loader.areaUp(CONST.loaderPrefix + area),
        down: () => Vue.loader.areaDown(CONST.loaderPrefix + area)
    });

    let responseInterceptors = response({
        down: () => Vue.loader.areaDown(CONST.loaderPrefix + area)
    });

    // axios REQUEST interceptor
    axiosInstance.interceptors.request.use(requestInterceptors[0], requestInterceptors[1]);

    // axios RESPONSE interceptor
    axiosInstance.interceptors.response.use(responseInterceptors[0], responseInterceptors[1]);

    return axiosInstance;
},
silent = () =>
{
    let axiosInstance = axios.create();

    return axiosInstance;
},
request = (callbacks) =>
{
    return [
        (config) =>
        {
            callbacks.up();
            return config;
        },

        (error) =>
        {
            callbacks.down();
            return Promise.reject(error);
        }
    ];
},
response = (callbacks) =>
{
    return [
        (response) =>
        {
            callbacks.down();
            return response;
        },

        (error) =>
        {
            if (loggingOut) return;

            if (error.response.status == 401 && error.response.data.logout)
            {
                loggingOut = true;

                Vue.modal.show(Vue.t('error.token_mismatch.text'), () =>
                {
                    store.dispatch('auth/logout', success => {
                        loggingOut = false;
                        window.location = Vue.onduro.route('login.signin');
                    });
                });
            }

            else if (error.response.status == 503 || error.response.status == 504)
            {
                store.dispatch('app/maintenance', true);
            }

            else if (error.response.status != 422 && error.response.status != 409 && error.response.status != 413)
            {
                Vue.notify.error(Vue.t('error.whoops.title'), Vue.t('error.whoops.headline'));
            }

            callbacks.down();

            return Promise.reject(error);
        }
    ];
};

Http.install = function(Vue, options)
{
    // Axios interceptors for general loader
    let requestInterceptors = request({
        up: () => Vue.loader.up(),
        down: () => Vue.loader.down()
    });

    let responseInterceptors = response({
        down: () => Vue.loader.down()
    });

    // axios REQUEST interceptor
    axios.interceptors.request.use(requestInterceptors[0], requestInterceptors[1]);

    // axios RESPONSE interceptor
    axios.interceptors.response.use(responseInterceptors[0], responseInterceptors[1]);

    // register global methods
    Vue.http = axios;

    // instance methods
    Vue.prototype.$http = axios;

    // Add loaderaware
    Vue.http.__proto__.loader = loader;
    Vue.prototype.$http.__proto__.loader = loader;

    // Add silent requests
    Vue.http.__proto__.silent = silent;
    Vue.prototype.$http.__proto__.silent = silent;
};

export default Http;



// WEBPACK FOOTER //
// ./src/js/plugins/http.js